export default "__VITE_ASSET__BFB3BOYg__"